<div class="page-wrap height-100 black">
  <div class="session-form-hold">
    <mat-progress-bar mode="determinate" class="session-progress"></mat-progress-bar>
    <mat-card>
      <mat-card-content>
        <!-- Language Switcher -->
        <div class="session-language-select">
          <language-switcher></language-switcher>
        </div>
        <div class="text-center pt-8 pb-16">
          <img width="60px" src="assets/images/logo-lg.png" alt="" class="mb-05">
           <h2>{{ 'Sign in with your domain name' | translate }}</h2>
          <p class="text-muted m-0">{{ 'Enter your Team Tracker URL' | translate }}</p>
        </div>
        <form [formGroup]="signinForm"  (ngSubmit)="signin()">
          <div>
            <mat-form-field class="full-width">
              <label>
                <input matInput formControlName="name" placeholder="{{ 'Subdomain' | translate}}" style="text-align: right">
              </label>
              <span matSuffix>{{ baseDomain }}</span>
              </mat-form-field>
              <mat-error *ngIf="signinForm.controls['name'].hasError('required') && signinForm.controls['name'].touched"
                         class="form-error-msg-large">{{ 'Field is required' | translate }}</mat-error>
              <mat-error *ngIf="notExistsErr && !signinForm.controls['name'].dirty"
                          class="form-error-msg-large">{{ 'Entered URL does not exist' | translate }}</mat-error>
          </div>

          <button mat-raised-button class="mat-primary full-width mb-1" [disabled]="signinForm.invalid">{{ 'Sign in' | translate }}</button>
          <div class="text-center">
            <a id="create-new-company-button" [routerLink]="'/sessions/signup'"
               class="mat-primary text-center full-width">{{ 'Create a new account' | translate }}</a>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
